export class OrderStyle {
	modelId?: number;
	colorId?: number;
	sizeId?: number;
	orderId?: number;

	constructor(init?: Partial<OrderStyle>) {
		Object.assign(this, init);
	}
}
